import React, { useEffect, useState } from "react";
import Loading from "../../Loading/Loading";
import { submitCaptcha } from "../../../Utils/captcha";
import config from "../../../config";
import { useLocation, useNavigate } from "react-router-dom";

const base_url=config.base_url
export function CaptchaTroughpass({api_endpoint, alternativeCode, alternativeModal ,success_link, error_link='/'}){
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search);
  const jwttoken = queryParams.get('token');
  const [modal, showModal] = useState()
  const [status, setStatus] = useState('Loading')
  const apiRequest = (captcha_token, jwttoken) =>{
    fetch(base_url+`${api_endpoint}`, {
      method: 'POST',
      mode: 'cors',
      headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-type': 'application/x-www-form-urlencoded',
          'credentials':'include'
      },
      body: `token=${captcha_token}&jwttoken=${jwttoken}`,
      credentials:'include'
    }).then((res)=>{
      if (res.status===200) return navigate(success_link, {replace:true, state:{token:true}})
      else if (res.status===alternativeCode) showModal(alternativeModal)
      else throw new Error(res.text())
    }).catch(e=>{
      console.log(e)
      setStatus('Something went wrong')
      setTimeout(()=>{
        navigate(error_link)
      }, 3000)
    })
  }
    useEffect(() => {
      if (!jwttoken) {console.log('Missing token'); return  navigate('/')}
      if (!api_endpoint || !success_link){console.log('Missing fields '); navigate(error_link); return }
      setStatus('Loading captcha')
      const script = document.createElement("script")
      script.src = "https://www.google.com/recaptcha/api.js?render=6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu"
      document.body.appendChild(script)
      setStatus('Validating captcha')
      submitCaptcha().then(captcha_token=>{
          setStatus('Processing')
          return apiRequest(captcha_token, jwttoken)
      })
      .catch(e=>{
          setStatus('A problem occurred')
          console.log(e)
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        modal?modal:<Loading text={status} />
      );
}